import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import { useI18n } from '../context/I18nContext';
import { LogoIcon } from '../components/Icons';

const Login = () => {
  const { settings } = useSettings();
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Side - Form */}
      <div className="flex-1 flex flex-col justify-center px-20 bg-white">
        <Link to="/" className="flex items-center gap-3 mb-12">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center">
            <LogoIcon className="w-6 h-6 text-white" />
          </div>
          <span className="text-2xl font-bold text-gray-900">{settings.companyName}</span>
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('login.welcome')}</h1>
        <p className="text-gray-600 mb-8">{t('login.subtitle')}</p>

        <form onSubmit={handleSubmit} className="max-w-md">
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-900 mb-2">{t('login.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-4 bg-gray-50 rounded-lg border-0 focus:ring-2 focus:ring-whatsapp outline-none"
              placeholder={t('login.emailPlaceholder')}
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-900 mb-2">{t('login.password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-12 px-4 bg-gray-50 rounded-lg border-0 focus:ring-2 focus:ring-whatsapp outline-none"
              placeholder="••••••••"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-whatsapp text-white font-semibold rounded-lg hover:bg-whatsapp-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? t('login.submitting') : t('login.submit')}
          </button>

        </form>
      </div>

      {/* Right Side - Branding */}
      <div className="flex-1 bg-gradient-to-br from-blue-500 to-indigo-600 flex flex-col items-center justify-center p-20">
        <div className="text-center text-white">
          <h2 className="text-4xl font-bold mb-4">{t('login.brandTitle')}</h2>
          <p className="text-lg opacity-90">
            {t('login.brandSubtitle')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
